import type { DataStatus } from '@/shared/lib';

interface ProductApplicationBase {
  id: string;
  productId: string;
  createdAt: string;
  updatedAt: string;
}

export interface WebApplication extends ProductApplicationBase {
  platform: ApplicationType.web;
  name: string;
  webUrl: string;
}

export interface AndroidApplication extends ProductApplicationBase {
  platform: ApplicationType.android;
  name: string;
  logoUrl: string;
  bundleId: string;
  integrationId: string;
}

export interface iOSApplication extends ProductApplicationBase {
  platform: ApplicationType.ios;
  bundleId: string;
  name: string;
  logoUrl: string;
  appstoreId: string;
  integrationId: string;
}

export enum ApplicationType {
  web = 'web',
  android = 'android',
  ios = 'ios',
}

export type ProductApplication =
  | WebApplication
  | AndroidApplication
  | iOSApplication;

export enum WebLinkType {
  webFunnel = 'web funnel',
  web2App = 'web2app',
}
export interface ProductWebfunnelLink {
  id: string;
  url: string;
  type: WebLinkType;
  productId: string;
  createdAt: string;
  updatedAt: string;
}

export interface Product {
  id: string;
  name: string;
  applications: ProductApplication[];
  webfunnelLinks: ProductWebfunnelLink[];
  webfunnelLinksDataStatus: DataStatus;
  createdAt: string;
  updatedAt: string;
}
